<template>
    <div>
        <error :name="'404'" :desc="'抱歉，你访问的页面不存在'"></error>
    </div>
</template>

<script>
    import error from '@/components/error.vue';
    export default {
        components: {
            error
        }
    }
</script>
